import type { Nullable } from "@iot-platform/core";
import { ToastManagerRepository } from "@iot-platform/core";
import type { User, UserEdit } from "@user/domain/models/user.model";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { userTypes } from "@user/root/user-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class UserEditUseCase {
    constructor(
        @inject(userTypes.repositories.UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    async execute(user: UserEdit): Promise<Nullable<User>> {
        const editResult = await this.userRepository.edit(user);

        if (editResult.isErr()) {
            const error = editResult.error.message;

            ToastManagerRepository.error(error);
        }

        return editResult.match(
            (userEdited) => userEdited,
            () => null,
        );
    }
}
